module.exports = "//static.hsappstatic.net/LoginUI/static-1.8917/img/apple-logo.png"